// extracted by mini-css-extract-plugin
export var select = "_q1-0";